module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pn",
    attrs: {
      "id": "part1"
    }
  }, [_c('a', {
    attrs: {
      "id": "pXX"
    }
  }), _c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v("PART I")]), _vm._v(" "), _c('p', {
    staticClass: "pt-orna"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pt-ornament.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt"
  }, [_vm._v("YOUNG CHARLES")]), _vm._v(" "), _c('p', {
    staticClass: "pt-epi"
  }, [_c('i', [_vm._v("‘We are delighted that our grandson Charles takes so much pleasure in hunting, because otherwise one might think he was a bastard.’")])]), _vm._v(" "), _c('p', {
    staticClass: "pt-epi-credit"
  }, [_vm._v("Emperor Maximilian to Margaret of Austria, 28 February 1510")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff1fe76a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part_01.vue
// module id = 78
// module chunks = 0